export default __webpack_public_path__ + "static/media/farming.47ce03d5.png";